export default __webpack_public_path__ + "static/media/Breastplate of the Renegade.f8bfaa4d.jpg";